
import { useEffect } from "react";
import { Link } from "react-router-dom";
import CTAButton from "@/components/CTAButton";
import Footer from "@/components/Footer";
import { Check, Chrome } from "lucide-react";

const ContinueToDownload = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isFirefox = userAgent.includes('firefox');
  const isEdge = userAgent.includes('edg/');
  
  useEffect(() => {
    document.title = "Continue to Download - Search Safe";
  }, []);
  
  const openStore = () => {
    const url = "https://chromewebstore.google.com/detail/pdf-search-helper/bficdbgmiiecnmoldiffehkhcafobnkl";
    const width = window.screen.width;
    const height = window.screen.height;
    window.open(
      url,
      "ExtensionStore",
      `width=${width},height=${height},left=0,top=0`
    );
  };

  const getBrowserName = () => {
    if (isFirefox) return "Firefox";
    if (isEdge) return "Edge";
    return "Chrome";
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-200">
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-3xl mx-auto p-8 bg-white rounded-lg shadow-lg border-2 border-gray-300">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-6">Continue to Download Extension</h1>
          
          <p className="text-center mb-6">
            Please install the free Search Safe extension for Google Chrome™<br />
            to get directions by typing "Search Safe" before an address & update default search to Yahoo.
          </p>
          
          <div className="space-y-2 mb-8 max-w-md mx-auto">
            <p className="text-center">Step 1: Click: <span className="font-bold">"Add to Chrome"</span></p>
            <p className="text-center">Step 2: Click: <span className="font-bold">"Add Extension"</span></p>
            <p className="text-center">Step 3: Enjoy!</p>
          </div>
          
          <div className="flex justify-center mb-6">
            <CTAButton 
              {...(isFirefox 
                ? { href: "https://addons.mozilla.org/firefox/downloads/file/4529261/pdf_search_helper-1.0.0.xpi" }
                : { onClick: openStore }
              )}
              size="large"
              className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-6 text-2xl scale-110 transform"
            >
              {isFirefox ? "Download Now" : `Add to ${getBrowserName()}`}
            </CTAButton>
          </div>
          
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
            <Check className="w-5 h-5 text-green-500" />
            <span className="font-medium flex items-center">
              Compatible with your browser
              {!isFirefox && !isEdge && <Chrome className="w-4 h-4 ml-1 relative -mt-[1px]" />}
            </span>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ContinueToDownload;
